<!-- Sidebar -->
<app-sidebar></app-sidebar>
<div>
  <app-header></app-header>
  <!-- Page Content -->
  <div id="content">
    <app-protocolos-pendetes-aprovacao-comercial></app-protocolos-pendetes-aprovacao-comercial> 
  </div>
  <app-footer></app-footer>
</div>